import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonPage,
} from '@ionic/react';
import PublicToolbar from '../../components/PublicToolbar';

const SupportPage: React.FC = (props) => {
  return (
    <IonPage>
      <IonHeader>
        <PublicToolbar title='Supporto'></PublicToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className='container mx-auto py-4 px-4'>
          <h1>Supporto People CDRT</h1>

          <div className='my-8'>
            <h2>Accedi o registrati</h2>
            <div className='mt-4'>
              <IonButton routerLink='/auth/sign-in' className='mx-2'>
                Accedi
              </IonButton>
              <IonButton routerLink='/auth/sign-up' className='mx-2'>
                Registrati
              </IonButton>
            </div>
          </div>

          <div>
            <h2>Domande frequenti</h2>
            <IonAccordionGroup className='mt-4'>
              <IonAccordion value='sign-up'>
                <IonItem slot='header' color='light'>
                  <IonLabel>Come posso registrarmi?</IonLabel>
                </IonItem>
                <div className='ion-padding flex items-center' slot='content'>
                  Per registrar eil tuo account devi andare nella pagina di{' '}
                  <IonButton className='mx-2' routerLink='/auth/sign-up'>
                    registrazione
                  </IonButton>
                  e compilare il form con i tuoi dati.
                </div>
              </IonAccordion>
              <IonAccordion value='sign-in'>
                <IonItem slot='header' color='light'>
                  <IonLabel>Come accedo all'app</IonLabel>
                </IonItem>
                <div className='ion-padding flex items-center' slot='content'>
                  Se hai già un account su questa app puoi accedere dalla pagina
                  di
                  <IonButton className='ml-2' routerLink='/auth/sign-in'>
                    login
                  </IonButton>
                </div>
              </IonAccordion>
              <IonAccordion value='delete-account'>
                <IonItem slot='header' color='light'>
                  <IonLabel>Posso cancellare il mio account?</IonLabel>
                </IonItem>
                <div className='ion-padding' slot='content'>
                  Si puoi cancellare il tuo account dal tuo profilo una volta
                  effettuato il login, o mandarci un email a
                  cdrtconsorzio@gmail.com
                </div>
              </IonAccordion>
              <IonAccordion value='contact'>
                <IonItem slot='header' color='light'>
                  <IonLabel>Come posso contattarvi?</IonLabel>
                </IonItem>
                <div className='ion-padding' slot='content'>
                  Puoi inviarci un email all'indirizzo{' '}
                  <a
                    href='mailto:cdrtconsorzio@gmail.com'
                    className='text-primary'
                  >
                    cdrtconsorzio@gmail.com
                  </a>
                </div>
              </IonAccordion>
            </IonAccordionGroup>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SupportPage;
